import { endpoints } from 'zylo_schema/contracts/endpoints';
type userResponse = endpoints['get_user']['responses'];
type R<T> = T extends { status: 200 } ? T : never;
export type user = R<userResponse>['data'];

export const usersStore: user[] = [
  {
    id: 0,
    posts: [
      5,
      19,
      31,
      36,
    ],
    pick_count: 34,
    bio: 'Travel enthusiast sharing hidden gems from around the world. Adventure is out there! 🌍✈️',
    name: 'Dana D',
    follower_count: 1250,
  },
  {
    id: 1,
    posts: [
      0,
      2,
      3,
      4,
      16,
      21,
      23,
      28,
      35,
    ],
    pick_count: 45,
    bio: 'Foodie and lifestyle blogger exploring the best eats and retreats. Let\'s make every day delicious! 🍴✨',
    name: 'Ahmed Khalid',
    follower_count: 183,
  },
  {
    id: 2,
    posts: [
      10,
      11,
      12,
      13,
      22,
      24,
      26,
      27,
      29,
      30,
      34,
    ],
    pick_count: 22,
    bio: 'Photographer capturing the essence of places, people, and moments. DM for collabs 📸',
    name: 'Aria Patel',
    follower_count: 98,
  },
  {
    id: 3,
    posts: [
      1,
      8,
      14,
      20,
      25,
    ],
    pick_count: 56,
    bio: 'Luxury travel curator and hotel critic. Helping you find your next dream stay! 🏖️🌟',
    name: 'James Sinclair',
    follower_count: 250,
  },
  {
    id: 4,
    posts: [
      6,
      7,
      9,
      15,
      17,
      18,
      32,
      33,
    ],
    pick_count: 30,
    bio: 'Solo Travel | Shopping | Sport | Adventure. Adventure awaits those who seek it 🌪',
    name: 'Sarah Alali',
    follower_count: 378,
  },
];
